import styled from 'styled-components';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  ${(props) => (props.fixedSize ? 'table-layout: fixed;' : '')}
`;

export default StyledTable;
